/**
 * Keys used to create and identify items on browser's storage
 */
export default {
  userCoordinates: 'drsmile-user-geolocation',
  userData: 'drsmile-user-data',
};
